import {Options} from '@fl/cmsch-fe-library';

import {BasicRole} from 'api/gen/BasicRole';

/**
 * Maps roles into select options for role pickers.
 *
 * @param roles - The roles to convert.
 * @returns Select options built from the provided roles.
 */
export const genRoleOption = (roles: Array<BasicRole>): Options<number> => roles.map(role =>
    ({value: role.id, label: `${role.code} (${role.name})`}),
);
